import React from 'react'
import { Header1 } from '../../components/headers/Header1'
import { Header2 } from '../../components/headers/Header2'
import { navItems } from '../../utils/navItems'

export default function HeadersPage() {
  return (
    <div className="relative space-y-16 py-12 bg-gray-50 min-h-screen">
      <section className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 pb-2 border-b">
          Header Showcase
        </h2>

        <div className="bg-white rounded-lg shadow-md  mb-12">
          <div className="p-4 bg-gray-100 border-b">
            <h3 className="font-medium text-gray-700">Header 1</h3>
          </div>
          <Header1 navItems={navItems} isDemo />
        </div>

        <div className="bg-white rounded-lg shadow-md ">
          <div className="p-4 bg-gray-100 border-b">
            <h3 className="font-medium text-gray-700">Header 2</h3>
          </div>
          <Header2 navItems={navItems} isDemo />
        </div>
      </section>
    </div>
  )
}
